import { EXPERT_LISTINGS_SOURCE } from '../constants';
import { BI_PAGE_NAMES } from '../../../../../../shared/services/BIEvents/constants';

export const MIXPANEL_EVENT_TYPES = {
    CLICKED_LISTING_TOGGLE: 'Clicked Listings Toggle',
};

export const MIXPANEL_PAGE_NAMES = {
    [EXPERT_LISTINGS_SOURCE]: 'Expert Listings',
    [BI_PAGE_NAMES.LISTINGS]: 'Listings Page',
};
